import React, { useEffect } from "react";
import { Row, Col } from "antd";
import { AimOutlined, HeartOutlined, ReadOutlined } from "@ant-design/icons";
import axios from "axios";

const ACCENT = "#27b2c4";

const highlights = [
  {
    icon: <AimOutlined />,
    title: "Our Mission",
    text: "To empower and inspire confidence in every customer with traditional craftsmanship and timeless beauty.",
  },
  {
    icon: <HeartOutlined />,
    title: "Our Values",
    text: "We believe in honesty, quality, and preserving culture through every design and detail.",
  },
  {
    icon: <ReadOutlined />,
    title: "Our Story",
    text: "Started from a small shop, now serving thousands online with heritage-inspired jewellery worldwide.",
  },
];

const AboutUs = () => {
  useEffect(() => {
    logUserActivity();
    document.title = "JOJ | About Us";
  }, []);

  const logUserActivity = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      const jsondata = JSON.stringify({
        ScreenID: "5",
        DetailID: "0",
      });

      let config = {
        method: "post",
        url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
        data: jsondata,
      };

      axios
        .request(config)
        .then((response) => {})
        .catch((error) => {});
    } catch (err) {}
  };

  return (
    <div style={{ background: "#fff" }}>
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "40px 20px 64px",
        }}
      >
        {/* Banner */}
        <div
          style={{
            borderRadius: 20,
            overflow: "hidden",
            marginBottom: 44,
            boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
          }}
        >
          <img
            src="https://thejoj.com/images/JOJAboutUS.jpg"
            alt="About us banner"
            style={{
              width: "100%",
              maxHeight: 380,
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>

        {/* Heading + intro */}
        <div style={{ textAlign: "center", maxWidth: 680, margin: "0 auto 52px" }}>
          <h1
            style={{
              fontSize: 32,
              fontWeight: 700,
              letterSpacing: -0.5,
              margin: 0,
              color: "#1f1f1f",
            }}
          >
            About Us
          </h1>
          <p
            style={{
              marginTop: 16,
              color: "#595959",
              fontSize: 16,
              lineHeight: 1.75,
            }}
          >
            Welcome to our store! We specialize in exquisite traditional
            jewellery, celebrating cultural heritage with each handcrafted
            piece. From royal Rajputi Aad to intricate Kundan sets, we're
            committed to quality, beauty, and customer satisfaction.
          </p>
        </div>

        {/* Highlights */}
        <Row gutter={[24, 24]} justify="center">
          {highlights.map((item) => (
            <Col xs={24} md={8} key={item.title}>
              <div
                style={{
                  height: "100%",
                  padding: "28px 24px",
                  borderRadius: 16,
                  border: "1px solid #f0f0f0",
                  background: "#fff",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    width: 52,
                    height: 52,
                    borderRadius: "50%",
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "rgba(39,178,196,0.1)",
                    color: ACCENT,
                    fontSize: 22,
                    marginBottom: 16,
                  }}
                >
                  {item.icon}
                </div>
                <h3
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    margin: "0 0 8px",
                    color: "#1f1f1f",
                  }}
                >
                  {item.title}
                </h3>
                <p
                  style={{
                    margin: 0,
                    color: "#8c8c8c",
                    fontSize: 14.5,
                    lineHeight: 1.7,
                  }}
                >
                  {item.text}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default AboutUs;
